import { Button } from '@ads/components-react';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Route = createFileRoute('/_authenticated/unauthorized/')({
  component: UnauthorizedPage,
});

export function UnauthorizedPage() {
  const { t } = useTranslation('common');

  return (
    <div className="flex h-full flex-col items-center justify-center gap-xs text-center">
      <div className="flex flex-col items-center gap-mini">
        <ShieldExclamationIcon className="h-xxl w-xxl text-ctx-content-title" />
        <h1 className="ts-heading-md text-ctx-content-title">{t('unauthorized.title')}</h1>
        <p className="ts-paragraph-sm text-ctx-content-base max-w-sm">
          {t('unauthorized.description')}
        </p>
      </div>
      <Link to="/">
        <Button hierarchy="primary" size="md">
          {t('unauthorized.backHome')}
        </Button>
      </Link>
    </div>
  );
}
